/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react' 

type Props<T> = {
  className: string,
  hasCheckBox: boolean,
  header: string,
  sub_header: string,
  headers: string[],
  data: T[],
  renderItem: (item: T) => React.ReactNode;
}

//const TableWithAction<T,>: React.FC<Props<T>> = ({className,header,sub_header,headers}) => {
  const TableWithAction = <T,>({
    className,
    hasCheckBox,
    header,
    sub_header,
    headers,
    data,
    renderItem,
  }: Props<T>) => {
  return (
    <div className={`card ${className}`}> 
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-3 mb-1'>{header}</span>
          <span className='text-muted mt-1 fw-bold fs-7'>{sub_header}</span>
        </h3> 
      </div> 
      <div className='card-body py-3'> 
        <div className='table-responsive'> 
          <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'> 
            <thead>
              <tr className='fw-bolder text-muted'>
                {hasCheckBox && (<th className='w-25px'>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value='1'
                      data-kt-check='true'
                      data-kt-check-target='.widget-13-check'
                    />
                  </div>
                </th>)}
                {headers.map((h, idx) => (
                  <th className='min-w-150px' key={idx}>{h}</th>
                ))} 
                <th className='min-w-100px text-end'>Actions</th>
              </tr>
            </thead> 
            <tbody>
               {data.map((item, idx) => (
                <React.Fragment key={idx}>{renderItem(item)}</React.Fragment>
              ))}
            </tbody> 
          </table> 
        </div> 
      </div> 
    </div>
  )
}

export {TableWithAction}
